<template>
  <div class="container">
    <v-head></v-head>
    <v-left current="activity"></v-left>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="优惠券" name="coupon"></el-tab-pane>
        <el-tab-pane label="设置" name="promotion"></el-tab-pane>
      </el-tabs>
      <component :is="activeName"></component>
    </div>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const coupon = (resolve) => require(["@/pages/activity/coupon/_list"], resolve);

export default {
  components: {
    "v-head": head,
    "v-left": left,
    coupon,
  },
  data() {
    return {
      activeName: "coupon",
    };
  },
  methods: {
    handleClick(e) {},
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/activity/Index.vue